<template>
  <div>
    <br>Disclaimer: Calculations must be re-checked. The shown results can be different from the calculated results because of rounding.
    <br>©2020 - KMPlab. All rights reserved.
  </div>
</template>

<script>
export default {
  name: "Kmpfooter"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
